import CheckboxColumn, { cellType, checkboxColumnConfiguration } from './CheckboxColumn.component';

export { cellType, CheckboxColumn };
export default checkboxColumnConfiguration;
